import React, { FC, memo } from 'react'

import { TypicalAccommodationsSectionTransport } from '../../../transports/region-landing-page-transport'
import ExternalLink from '../../common/external-link'
import {
    BungalowStyledIcon,
    CampingplatzStyledIcon,
    Container,
    FerienhausStyledIcon,
    FerienwohnungStyledIcon,
    FincaStyledIcon,
    IconBox,
    InnerContainer,
    MenuContainer,
    MenuWrapper,
    SubtitleSpan,
    TitleSpan,
    VillaStyledIcon,
} from './styles'
import { useTranslation } from '../../../hooks/locale'
import { Title, TitleContainer } from '../common/styles'

const ICON_MAP: Record<string, React.ComponentType<React.SVGProps<SVGSVGElement>>> = {
    '1': FerienwohnungStyledIcon,
    '2': FerienhausStyledIcon,
    '3': VillaStyledIcon,
    '4': FincaStyledIcon,
    '5': BungalowStyledIcon,
    '19': CampingplatzStyledIcon,
    '20': BungalowStyledIcon,
}

interface Props {
    typicalAccommodationsSection: TypicalAccommodationsSectionTransport
}

const AccommodationSection: FC<Props> = ({ typicalAccommodationsSection }) => {
    const { t } = useTranslation()
    const { heading, items } = typicalAccommodationsSection

    return (
        <Container id="accommodation">
            <TitleContainer>
                <Title>{heading}</Title>
            </TitleContainer>
            <InnerContainer>
                {items.map(item => {
                    const Icon = ICON_MAP[item.id] ?? FerienwohnungStyledIcon
                    return (
                        <MenuWrapper key={item.link}>
                            <ExternalLink
                                as={MenuContainer}
                                title={item.linkTitle}
                                href={item.link}
                                noCrawl={item.noCrawl}
                            >
                                <IconBox>
                                    <Icon />
                                </IconBox>
                                <TitleSpan>{item.title}</TitleSpan>
                                <SubtitleSpan>
                                    {item.count} {item.count === 1 ? t('accommodation') : t('accommodations')}
                                </SubtitleSpan>
                            </ExternalLink>
                        </MenuWrapper>
                    )
                })}
            </InnerContainer>
        </Container>
    )
}

export default memo(AccommodationSection)
